import { DynamicFormControlModel, DynamicFormControlModelConfig } from '@ng-dynamic-forms/core';
import keyBy from 'lodash/keyBy';

export function getDynamicFormModelMap<T extends DynamicFormControlModel | DynamicFormControlModelConfig>(
  formModel: T[]
): Record<string, T> {
  return keyBy(formModel, 'id');
}
